import type React from 'react';
import {Button, Link, Stack, Typography} from '@mui/material';
import {Edit} from '@mui/icons-material';
import {HelpComponent} from '~/components/help-component/HelpComponent';

/** A section title with the app's help popout; it links to the analyses where the section is edited. */
export const HelpTitle: React.FC<{title: string; help: string; links: {label: string; onClick: () => void}[]}> = ({title, help, links}) => (
    <Stack direction="row" gap={0.5} alignItems="center" component="span">
        {title}
        <HelpComponent small helpContent={(
            <Stack gap={0.75} sx={{p: 1.5, maxWidth: 360}}>
                <Typography variant="body2">{help}</Typography>
                {links.map(l => (
                    <Link key={l.label} component="button" type="button" variant="body2" underline="always"
                          sx={{alignSelf: 'flex-start', fontWeight: 600}} onClick={l.onClick}>
                        {`Go to ${l.label} ›`}
                    </Link>
                ))}
            </Stack>
        )}/>
    </Stack>
);

/** "Edit in <analysis>": opens that analysis in Strategy formulation. */
export const EditIn: React.FC<{label: string; onClick: () => void}> = ({label, onClick}) => (
    <Button size="small" startIcon={<Edit/>} onClick={onClick}>{`Edit in ${label}`}</Button>
);
